import { render } from "./SingleLesson.vue?vue&type=template&id=a8f18436"
import script from "./SingleLesson.vue?vue&type=script&lang=js"
export * from "./SingleLesson.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ahmadsabri-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__